import { useState, useEffect } from "react";

// Hook for calculating deadline countdown
function useDeadlineCountdown(task) {
  const [countdown, setCountdown] = useState({ days: 0, hours: 0 });

  useEffect(() => {
    if (!task.hasDeadline && !task.isDeadline) {
      setCountdown({ days: 0, hours: 0 });
      return;
    }

    const updateCountdown = () => {
      if (!task.deadline) {
        setCountdown({ days: 0, hours: 0 });
        return;
      }
      const now = new Date();
      const deadlineDate = new Date(task.deadline);
      const diffMs = deadlineDate - now;
      if (diffMs <= 0) {
        setCountdown({ days: 0, hours: 0 });
        return;
      }
      const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      setCountdown({ days, hours });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 60000); // Update every minute
    return () => clearInterval(interval);
  }, [task.hasDeadline, task.isDeadline, task.deadline]);

  return countdown;
}

export default useDeadlineCountdown;
